import './App.scss';

function App() {
  return (
    <div className="App">
      La Grande Partie - LineUp 2025
    </div>
  );
}

export default App;
